import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-shield-protected-icon',
  templateUrl: './general-shield-protected.component.html'
})
export class GeneralShieldProtectedComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
